export default function Marquee({ t }) {
  const items = [...t.marquee, ...t.marquee];
  return (
    <section
      data-testid="marquee-section"
      className="relative z-10 overflow-hidden border-y border-gold/20 bg-forest py-5"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-lg italic tracking-wide text-cream/85 sm:text-xl">
              {item}
            </span>
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
          </span>
        ))}
      </div>
    </section>
  );
}
